import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save(props) {
	const { attributes } = props;
	const { content, grade } = attributes;
	const blockProps = useBlockProps.save({
		className: 'c4l-grading-value'
	});
	return (
		<div {...blockProps}>
			<div className="c4l-grading-value-container">
				<RichText.Content
					tagName='div'
					className='c4l-grading-value-content'
					value={content}
				/>
				<RichText.Content
					tagName='div'
					className='c4l-grading-value-grade'
					value={grade}
				/>
			</div>
		</div>
	);
}
